import { Flex, FlexProps, HtmlContainerTag } from "./flex";

export type StackProps<T extends HtmlContainerTag = "div"> = FlexProps<T> & {
  direction?: never;
  reverse?: boolean;
  spread?: boolean;
};

export const Stack = <T extends HtmlContainerTag = "div">({ reverse, spread, ...props }: StackProps<T>) => (
  <Flex
    direction={reverse ? "column-reverse" : "column"}
    justifyContent={spread ? "space-between" : undefined}
    {...props}
  />
);
